import { useState } from "react";
import { Button } from "react-bootstrap";

const Cheating = (() => {
    const [showModal, setShowModal] = useState(false);

    return (
        <>
        {showModal &&
        <div className="quiz-overlay">
            <div className="start-quiz">
                <p>
                    We have taken several measures to discourage the easiest forms of cheating on this app, but recognize how easy it is to take advantage of your fellow group mates. If you are the type to cheat your way through fun games, this is not the place for you. If we find strong evidence of someone cheating, we'll simply delete their account. Thanks and have fun!
                </p>
                <Button onClick={() => setShowModal(false)}>
                    Ok, thanks.
                </Button>
            </div>
        </div>}
        {!showModal &&
        <Button className="shadow-sm" variant={'danger'} onClick={() => setShowModal(true)}>
            See our policy on cheating
        </Button>
        }
        </>
    );
})

export default Cheating